import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-footer', 'footer', 'Footer');
